import { Box } from "theme-ui"
import { IInfo } from "@types"

interface props {
 single: IInfo
 hide: (_arg: any) => void
}
export const IntersectionPopup = ({ single,hide }: props) => {
 return (
  <div>
   <Box
    bg="light_gray"
    className="text-xs  shadow-2xl text-start rounded"
   >
    <div className="bg-[#d0e2ff] flex justify-between items-center px-2 py-2 rounded">
     <h1 className="font-bold text-lg">Info</h1>
     <div
      className="cursor-pointer"
        onClick={() => {
          hide((prev:boolean) => !prev)
        }}
     >
      <svg xmlns="http://www.w3.org/2000/svg" height="16" width="12" viewBox="0 0 384 512">
       <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
      </svg>
     </div>
    </div>
    <div className="relative -z-10">
     <Box
      bg="light_gray"
      className="absolute w-6 h-6 transform rotate-45 -translate-x-3 -top-[20px] left-[0px]"
     ></Box>
    </div>

    <ul className="list-disc py-2 px-4">
     <li>
      <span className="font-semibold text-md">Partialsystem</span>:{single.partial_system}
     </li>
     <li>
      <span className="font-semibold text-md">Model</span>:{single.model}
     </li>
     <li>
             {" "}
             <span className="font-semibold text-md">Code:</span>
             {single?.code}
            </li>
     <li>
      {" "}
      <span className="font-semibold text-md">Submodel:</span>
      {single.submodel}
     </li>
     <li>
      <span className="font-semibold text-md">Instance</span>:{single.instance}
     </li>
     <li>
      <span className="font-semibold text-md">Jobnumber</span>:{single.job_number}
     </li>
    </ul>
   </Box>
  </div>
 )
}
